import type { OptionType } from "../../../../../../types/types";

export {
  DownloadTemplateContainer,
  RegularTextBlock,
  TemplateButtonContainer,
  DocumentDownloadContainer,
  convertArrayBufferToZipUrl,
} from "../../../../../../components/DownloadTemplateFiles/DownloadTemplateFiles";

export const specialChar = "___";

// Entity profiles land in one of these statuses on upload; only these are
// valid for CSV export, so both the picker list and the export request are
// restricted to them.
export const DEFAULT_STATUSES = [
  "published",
  "unpublished",
  "draft",
  "staged",
  "unpublished_staged",
];

export const replaceDotsWithSpecialCharacter = (name: string): string =>
  name.replace(/\./g, specialChar);

export const revertSpecialCharacterReplace = (name: string): string =>
  name.replace(new RegExp(specialChar, "g"), ".");

export const getFileDateString = (): string => {
  const date = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const [month, day, year] = date.split("/");
  return `${year}-${month}-${day}`;
};

export type EntityUploadStages = "table" | "download" | "upload";

export type EntityUploadState = {
  uploadStage: EntityUploadStages;
  selectedTemplate?: OptionType<string>;
  showConfirmTemplateSelectionButton: boolean;
  collectionFileNames: Record<string, string>;
  selected_entities?: string[] | "all";
  export_id?: string;
};

export type EntityUploadAction = {
  type:
    | "select_template"
    | "confirm_template"
    | "set_export_id"
    | "set_selected_entities"
    | "continue_from_download"
    | "discard_template"
    | "move_back"
    | "complete";
  payload: EntityUploadState;
};
